export * from "./framed-image";
